import { render, staticRenderFns } from "./NhFeatureCard.vue?vue&type=template&id=4915b1c7"
import script from "./NhFeatureCard.vue?vue&type=script&lang=js"
export * from "./NhFeatureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports